import { getApiBaseUrl } from '../utils/config';

/**
 * API 응답 형식
 */
interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

/**
 * fetch 기반 POST 요청
 * - Content-Type: application/json
 * - 응답에서 success 체크, data 추출
 * - 에러 시 throw
 */
/**
 * fetch 기반 GET 요청
 */
export async function apiGet<T>(path: string): Promise<T> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}${path}`;

  let response: Response;
  try {
    response = await fetch(url);
  } catch {
    throw new Error('네트워크 오류가 발생했습니다.');
  }

  let json: ApiResponse<T>;
  try {
    json = await response.json() as ApiResponse<T>;
  } catch {
    throw new Error('서버 응답을 처리할 수 없습니다.');
  }

  if (!response.ok || !json.success) {
    throw new Error(json.error ?? `요청에 실패했습니다. (${response.status})`);
  }

  return json.data as T;
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const baseUrl = getApiBaseUrl();
  const url = `${baseUrl}${path}`;

  let response: Response;
  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  } catch (err) {
    throw new Error('네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
  }

  let json: ApiResponse<T>;
  try {
    json = await response.json() as ApiResponse<T>;
  } catch {
    throw new Error('서버 응답을 처리할 수 없습니다.');
  }

  if (!response.ok || !json.success) {
    throw new Error(json.error ?? `요청에 실패했습니다. (${response.status})`);
  }

  if (json.data === undefined) {
    throw new Error('서버 응답에 데이터가 없습니다.');
  }

  return json.data;
}
